(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["hv-react-ts-main"] = factory();
	else
		root["hv-react-ts-main"] = factory();
})(window, function() {
return 